var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaultBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vault",
    clipPath: "url(#clip0_501_25282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85735 5.35717V17.8929H6.00021H18.0002H20.1431V12.8572H18.7778C18.3761 14.992 16.5018 16.6072 14.2502 16.6072C11.7058 16.6072 9.64307 14.5445 9.64307 12C9.64307 9.45557 11.7058 7.39288 14.2502 7.39288C16.5018 7.39288 18.3761 9.00802 18.7778 11.1429H20.1431V5.35717H3.85735ZM17.014 11.1429C16.6487 9.96369 15.5495 9.10717 14.2502 9.10717C12.6525 9.10717 11.3574 10.4023 11.3574 12C11.3574 13.5977 12.6525 14.8929 14.2502 14.8929C15.5495 14.8929 16.6487 14.0364 17.014 12.8572H15.4813C15.2103 13.2458 14.7599 13.5 14.2502 13.5C13.4218 13.5 12.7502 12.8285 12.7502 12C12.7502 11.1716 13.4218 10.5 14.2502 10.5C14.7599 10.5 15.2103 10.7543 15.4813 11.1429H17.014ZM21.8574 18V12V5.25003C21.8574 4.36243 21.1378 3.64288 20.2502 3.64288H3.75021C2.86261 3.64288 2.14307 4.36243 2.14307 5.25003V18C2.14307 18.8876 2.86261 19.6072 3.75021 19.6072H5.14307V21C5.14307 21.4734 5.52682 21.8572 6.00021 21.8572C6.4736 21.8572 6.85735 21.4734 6.85735 21V19.6072H17.1431V21C17.1431 21.4734 17.5268 21.8572 18.0002 21.8572C18.4736 21.8572 18.8574 21.4734 18.8574 21V19.6072H20.2502C21.1378 19.6072 21.8574 18.8876 21.8574 18Z",
    fill: "#192851"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_25282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultBlack);
export default __webpack_public_path__ + "static/media/VaultBlack.04bbecf08c0eeafe2abedf8a6626eae0.svg";
export { ForwardRef as ReactComponent };